/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_LicensesInputs */

const en_gc_home_licenses = /** @type {(inputs: Gc_Home_LicensesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open-source license`)
};

const zh_gc_home_licenses = /** @type {(inputs: Gc_Home_LicensesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源许可`)
};

/**
* | output |
* | --- |
* | "Open-source license" |
*
* @param {Gc_Home_LicensesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_licenses = /** @type {((inputs?: Gc_Home_LicensesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_LicensesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_licenses(inputs)
	return zh_gc_home_licenses(inputs)
});
export { gc_home_licenses as "gc.home.licenses" }